import { render } from "./KeywordDetailView.vue?vue&type=template&id=fd301538&ts=true"
import script from "./KeywordDetailView.vue?vue&type=script&lang=ts"
export * from "./KeywordDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__